module.exports = __webpack_public_path__ + "img/questionmark2.cb225abf.svg";